(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared-2/assets/javascripts/components/selected-receivers.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared-2/assets/javascripts/components/selected-receivers.js');

'use strict';

const _svs$ui$ReactCard = svs.ui.ReactCard,
  Card = _svs$ui$ReactCard.Card,
  CardHeader = _svs$ui$ReactCard.CardHeader,
  CardBody = _svs$ui$ReactCard.CardBody,
  CardGroup = _svs$ui$ReactCard.CardGroup;
const Loader = svs.components.ReactLoader.Loader;
const ReactIcon = svs.ui.ReactIcon;
const links = svs.grassroots.links;
const SelectedReceivers = _ref => {
  let openBottomSheet = _ref.openBottomSheet;
  const _React$useContext = React.useContext(svs.grassroots.context.Context),
    _React$useContext$sel = _React$useContext.selectedReceivers,
    selectedReceivers = _React$useContext$sel.selectedReceivers,
    isLoading = _React$useContext$sel.isLoading;
  const onClickHandler = receiver => {
    openBottomSheet(receiver);
    window.history.replaceState(null, null, "".concat(svs.core.data.baseUrl).concat(links.single(receiver.id, receiver.longname)));
  };
  if (!svs.grassroots.shared.data.isCorporateSite && svs.core.userSession && svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
    return React.createElement(Card, {
      branding: "sport",
      className: "grassroots-".concat(svs.grassroots.background)
    }, React.createElement("div", {
      className: "grassroots-selected-receivers-container"
    }, React.createElement(CardHeader, {
      className: "grassroots-".concat(svs.grassroots.background)
    }, "Mina f\xF6reningar"), React.createElement(CardBody, null, isLoading && React.createElement(Loader, {
      size: 300
    }), !isLoading && selectedReceivers.length === 0 && React.createElement("p", {
      className: "align-center"
    }, React.createElement("span", {
      className: "f-italic"
    }, "Just nu st\xF6ttar du inte n\xE5gra f\xF6reningar."), React.createElement("br", null), React.createElement("span", {
      className: "f-medium"
    }, "Anv\xE4nd s\xF6kf\xE4ltet i toppen f\xF6r att v\xE4lja upp till 3 f\xF6reningar som du vill st\xF6tta.")), !isLoading && selectedReceivers && selectedReceivers.length > 0 && React.createElement(CardGroup, null, [...Array(3)].map((e, i) => {
      if (selectedReceivers[i]) {
        return React.createElement(Card, {
          branding: svs.grassroots.tenant,
          className: "grassroots-selected-receiver-card pointer",
          key: selectedReceivers[i].id,
          onClick: () => onClickHandler(selectedReceivers[i])
        }, React.createElement(CardBody, null, React.createElement("h2", {
          className: "grassroots-selected-receiver-title h4"
        }, selectedReceivers[i].longname), React.createElement("p", {
          className: "grassroots-selected-receiver-text"
        }, selectedReceivers[i].subcategory === '' ? 'Huvudförening |' : "".concat(selectedReceivers[i].subcategory, " |"), ' ', selectedReceivers[i].location.city),
        selectedReceivers[i].forcedinvalidation || selectedReceivers[i].forcedInvalidation ? React.createElement("div", {
          className: "grassroots-selected-receiver-invalid margin-v-1"
        }, React.createElement("p", null, "F\xF6reningen finns inte l\xE4ngre i Gr\xE4sroten."), React.createElement("p", null, "Klicka h\xE4r f\xF6r att avsluta ditt st\xF6d.")) : React.createElement("p", null, React.createElement(ReactIcon, {
          className: "padding-right-1",
          icon: "players"
        }), React.createElement("span", null, selectedReceivers[i].supporters.toLocaleString('sv-SE'), ' ', "st"), React.createElement(ReactIcon, {
          className: "margin-left-1 padding-right-1",
          icon: "points"
        }), selectedReceivers[i].points.toLocaleString('sv-SE'), ' ', "p")));
      }
      return (
        React.createElement(Card, {
          className: svs.grassroots.background,
          key: i
        }, React.createElement(CardBody, {
          className: "u-flex u-flex-align-items-center"
        }, React.createElement("p", {
          className: "align-center margin-v-1-half"
        }, "Det finns plats f\xF6r en till f\xF6rening.", React.createElement("br", null), React.createElement("span", {
          className: "f-medium"
        }, "Anv\xE4nd s\xF6kf\xE4ltet i toppen och v\xE4lj en till f\xF6rening som du vill st\xF6tta."))))
      );
    })))));
  }
  return null;
};
svs.grassroots.components.SelectedReceivers = SelectedReceivers;

 })(window);